import WarrantyRegistrationsi18n from 'src/components/warrantyRegistrations/i18n';

export default {
  // Main Layout
  mainLayout: {
    title: 'App Template',
    greeting: 'Hello, {user}!',
    changePassword: 'Change Password',
    editProfile: 'Edit Profile',
    logout: 'Logout',
    primaryDealerLocation: 'Primary Dealer Location',
    adminActions: 'Admin Actions',
    linkDashboard: 'Dashboard',
    dealerSaleOrder: 'Sales Order',
    linkWarrantyRegistrations: 'Warranty Registrations',
    linkWarrantyClaims: 'Warranty Claims',
    linkDealerLocator: 'Dealer Locator',
    linkManageUsers: 'Manage Users',
    linkManageRoles: 'Manage Roles',
    linkManageEmails: 'Manage Emails',
    linkManageVehicles: 'My RV',
    linkNotifications: 'Notifications',
    linkInformationalVideos: 'How-To Videos',
    linkUnitInformation: 'Unit Information',
    linkSupport: 'Support',
    linkFaq: 'FAQ',
    linkChecklists: 'Checklists',
    linkBlogPosts: 'Campfire Stories',
    linkPodcasts: 'Podcasts',
    linkMarketingMaterials: 'Marketing Materials',
  },

  // 404 Page
  notFound: {
    message: 'Oops. Nothing here...',
    homeLink: 'Go Home',
  },

  // Login Page
  login: {
    title: 'Login',
    username: 'Email *',
    usernameRequired: 'Email is required',
    password: 'Password *',
    passwordRequired: 'Password is required',
    forgotPassword: 'Forgot password?',
    register: 'Register',
    signIn: 'Sign in',
  },

  /////////////////////////////////////////////////////////////////////////////////
  // Account

  changePassword: {
    title: 'Change Password',
    instructions: 'Please enter a new password:',
    currentPassword: 'Current Password *',
    currentPasswordRequired: 'Current Password is required',
    newPassword: 'New Password *',
    newPasswordRequired: 'New Password is required',
    confirmNewPassword: 'Confirm New Password *',
    confirmNewPasswordRequired: 'Confirm New Password is required',
    successMessage: 'Success! Your password has been changed.',
  },

  confirmEmail: {
    title: 'Confirm Email',
    loadingMessage: 'Confirming your email...',
    successMessage: 'Success! Your email has been confirmed.',
    continueToLogin: 'Continue to login',
  },

  editProfile: {
    title: 'Edit Profile',
    saveChanges: 'Save Changes',
    resetProfile: 'Reset',
    successMessage: 'Success! Your profile has been updated.',
  },

  forgotPassword: {
    title: 'Forgot Password',
    instructions: "Please enter your account's current email address:",
    email: 'Email *',
    emailRequired: 'Email is required',
    recover: 'Recover',
    successMessage: 'An email has been sent to {email} if this account exists.',
  },

  register: {
    title: 'Register',
    firstName: 'First Name *',
    firstNameRequired: 'First Name is required',
    lastName: 'Last Name *',
    lastNameRequired: 'Last Name is required',
    email: 'Your Email *',
    emailRequired: 'Email is required',
    phone: 'Phone Number *',
    phoneError: 'Please enter a valid phone number',
    streetAddress: 'Street Address *',
    streetAddressRequired: 'Street Address is required',
    city: 'City *',
    cityRequired: 'City is required',
    zip: 'Zip / Postal Code *',
    zipRequired: 'Zip / Postal Code is required',
    state: 'State / Province *',
    stateRequired: 'State / Province is required',
    country: 'Country *',
    countryRequired: 'Country is required',
    password: 'Password *',
    passwordRequired: 'Password is required',
    confirmPassword: 'Confirm Password *',
    confirmPasswordRequired: 'Confirm Password is required',
    passwordDoesNotMatch: 'Password and Confirm Password must match.',
    successMessage: 'Success! An email has been sent to {email} to complete the registration process.',
    termsAndConditionsMessage: "By clicking Agree & Register you agree to {companyDisplayName}' ",
    agreeAndRegister: 'Agree & Register',
    invitationSuccessMessage: 'Success! Your account has been created',
  },

  resetPassword: {
    title: 'Reset Password',
    instructions: 'Please enter a new password:',
    newPassword: 'New Password *',
    newPasswordRequired: 'New Password is required',
    confirmNewPassword: 'Confirm New Password *',
    confirmNewPasswordRequired: 'Confirm New Password is required',
    successMessage: 'Success! Your password has been changed.',
    passwordDoesNotMatch: 'Password and Confirm Password must match.',
  },

  termsAndConditions: {
    termsAndConditionsMessage:
      "Our {name} have been updated. By clicking Agree & Continue you agree to {companyDisplayName}' updated ",
    agreeAndContinue: 'Agree & Continue',
  },

  //////////////////////////////////////////////////////////////////////////////////
  // Dealer

  dashboard: {
    pageTitle: 'Dashboard',
  },

  announcements: {
    title: 'Announcements',
    newAnnouncement: 'New Announcement',
    edit: 'Edit',
    addAttachments: 'Attachments',
    removeTitle: 'Remove Announcement',
    removeConfirm: 'Are you sure you want to remove this announcement?',
    removeSuccess: 'Success! Announcement successfully removed.',
    created: 'Created: ',
    updated: 'Updated: ',
    searchTitle: 'Search Title',
    tableColumns: {
      title: 'Title',
      published: 'Published',
    },
  },

  AnnouncementDialog: {
    createAnnouncement: 'Create Announcement',
    editAnnouncement: 'Edit Announcement',
    title: 'Title',
    expirationDate: 'Expiration Date',
    expirationDateError: 'Expiration Date must be in the future',
    addSuccess: 'Success! Announcement successfully created.',
    updateSuccess: 'Success! Announcement successfully updated.',
    contentRequired: 'Error! Content required',
    uploadMissing: 'Error! Not all added files have been uploaded',
    attachments: 'Attachments',
  },

  announcementAttachmentDialog: {
    attachmentsTitle: 'Announcement Attachments',
    titleLabel: 'Title',
    noAttachments: 'No attachments availble for this announcement',
    previewThumbnail: 'Preview Image',
    attachments: 'Attachments',
    addAttachments: 'Add Attachments',
    addSuccess: 'Success! Announcement attachments successfully added.',
    removeTitle: 'Remove Attachment',
    removeConfirm: 'Are you sure you want to remove this attachment: "{fileName}"',
    removeSuccess: 'Success! Attachment successfully removed.',
    unsubmittedAttachmentsTitle: 'Un-submitted Attachments',
    unsubmittedAttachmentsMsg: 'Are you sure you want to proceed without submitting added attachments?',
  },

  warranty: {
    recalls: {
      export: 'Export Recall VINS',
      mobileExport: 'Export',
      exportFileName: 'Recall-{recallId}-VINs',
      recallTitle: 'Warranty Recalls',
      recallDetailsTitle: 'Recall Details',
      recallCategory: 'Filter Type',
      vinHeader: 'VIN',
      accountNumberHeader: 'Account #',
      processedHeader: 'Processed',
      brandHeader: 'Brand',
      modelHeader: 'Model',
      yearHeader: 'Year',
      claim: 'Claim',
      recallIdHeader: 'Recall ID',
      recallNameHeader: 'Recall Name',
      recallTypeheader: 'Recall Type',
      warrantyCodeHeader: 'Warranty Code',
      warrantyDescriptionHeader: 'Description',
      recallDescriptionHeader: 'Description',
      attachment: 'attachment',
      productionBeginsHeader: 'Production Begins',
      productionEndsHeader: 'Production Ends',
      vinDetailsButton: 'VIN Details',
      processClaimButton: 'Process Claim',
      viewClaimButton: 'View Claim',
      downloadAttachment: 'Download File',
      openAttachment: 'Open File',
      shareAttachment: 'Share File',
      searchBox: 'SEARCH',
      globalSearchLabel: 'Global Search',
      includeClosedLabel: 'Include Closed',
      newClaim: 'New Claim',
      noVinInfoErr: 'Could not find VIN information for {vin}',
      markedForRetailSold: "Cannot create claim for VINS marked as 'Retail Sold - Stat Survey'",
      notRegisteredVinErr: 'Cannot create claim for unregistered vin {vin}',
    },
    attachments: {
      header: 'Attachments',
      noAttachmentsMessage: 'No Attachments for this Recall',
      close: 'Close Attachments',
    },
  },

  /////////////////////////////////////////////////////////////////////////////////
  // Admin

  manageEmails: {
    title: 'Manage Emails',
  },

  manageRoles: {
    title: 'Manage Roles',
    addRole: 'Add Role',
    systemRole: 'System Role',
    permissions: 'Permissions',
    roleNotFound: 'Selected role could not be found',
    deleteConfirm: 'Are you sure you want to delete the "{role}" role?',
    editRole: 'Edit Role',
    createRole: 'Create Role',
    roleName: 'Role Name *',
    roleNameRequired: 'Role Name is required',
  },

  manageUsers: {
    title: 'Manage Users',
    inviteDealerAdminTitle: 'Invite Dealer Admin',
    inviteDealerUserTitle: 'Invite Dealer User',
    chainGroup: 'Chain Group *',
    chainGroupRequired: 'Chain Group is required',
    currentTitle: 'Current Title *',
    currentTitleRequired: 'Current title is required',
    location: 'Location *',
    locationRequired: 'Location is required',
    inviteDealerAdmin: 'Invite Dealer Admin',
    inviteDealerAdminOverride: 'User {username} already exist. User role and locations successfully updated',
    inviteDealerUser: 'Invite Dealer User',
    firstName: 'First Name *',
    firstNameRequired: 'First Name is required',
    lastName: 'Last Name *',
    lastNameRequired: 'Last Name is required',
    email: 'Email *',
    emailRequired: 'Email is required',
    associatedWithChainGroup: 'Will this dealer be associated with a chain group?',
    associatedWithChainGroupRequired: 'Dealer location type is required',
    dealerAdminInviteSent: 'Success! A dealer account invitation has been sent to {email}.',
    dealerAdminEdit: 'Success! Dealer user has been updated.',
    dealerAccessRemoved: 'Success! Dealer access removed for {email}',
    resendInvite: 'Resend Invitation',
    removeAccess: 'Remove Access',
    removeLocations: 'Remove Locations',
    addLocations: 'Add Locations',
    roleTitle: 'Roles',
    locationChainGroup: 'Location / Chain Group *',
    registered: 'Registered',
    confirmResendConfirmationEmail: 'Are you sure you want to resend the invitation email to {email}?',
    invitationEmailSent: 'Success! Invitation email sent to {email}',
    confirmRemoveAccess: 'Are you sure you want to remove dealer access for user {email}?',
    lastLoginDate: 'Last Login Date',
    viewDealerAdmin: 'View Dealer Admin',
    viewDealerUser: 'View Dealer User',
    duplicateLocationSelections: 'Duplicate selection, select another option.',
    financeRoleDescription:
      'VIEW ACCESS - Registration, Recalls, Claims, Products, Invoices, Sales order, W9 Request, Spiff Request, Marketing and Customer resources',
    warrantyRoleDescription:
      'FULL ACCESS - Registration, Recalls, Claims, Products, Invoices, Sales order, Marketing and Customer resources',
    dealerSuperAdminRoleDescription: 'FULL ACCESS AND RIGHTS',
    dealerAdminRoleDescription:
      'FULL ACCESS - Registration, Invoices, Sales order, W9 and SPIFF.<br/>VIEW ACCESS - Recalls, Claims, Product Items',
    batchInviteDealerAdmin: 'Batch Invite Dealer Admins',
    batchInviteDealerUser: 'Batch Invite Dealer Users',
    importBatch: 'Import Batch',
    downloadAdminTemplate: 'Download Admin Template',
    downloadUserTemplate: 'Download User Template',
    emailImportResults: 'The results of this import will be emailed to {email}.',
    batchInviteQueueSuccess: 'Batch Invite Queue Success!',
    noLocaitonsError: 'Unable to retrieve user locations. Please contact Heartland Customer Service for assistance.',
  },
  batchInvite: {
    emailLabel: 'Enter Email Address',
    emailValidation: 'Enter A Valid Email',
  },
  /////////////////////////////////////////////////////////////////////////////////
  // Dealer

  dashboardChart: {
    claimsByStatus: 'Claims by Status',
    claimsInDealerActionStatus: 'Claims In Dealer Action Status',
    claimInPaymentStatus: 'Claims in Payment Status',
    salesOrderByStatus: 'Sale Order by Status',
    vinRegistration: 'Vin Registration',
    statement: "Today's Balance: ${balance}",
    numberOfClaimsByStatus: 'Number of Claims by Status',
    numberOfSalesByStatus: 'Number of Sales by Status',
    numberOfRegistrationsByStatus: 'Number of Registrations by Status',
    invoiceStatement: 'Balance Aging',
    exportInvoiceReport: 'Export Invoice Statement',
    flatRateCodeExport: 'Flat Rate Code Export',
  },

  claimDashboard: {
    new: 'New',
    preAuthorizationRequired: 'Pre Authorization Required',
    dealerFeedbackRequired: 'Dealer feedback required',
    awaitVendorApproval: 'Awaiting vendor approval',
    awaitWorkCompletion: 'Awaiting work completion',
    agingBucket: '91-120 aging bucket',
    ApprovedForPayment: 'Approved for payment',
    awaitingPaymentApproval: 'Awaiting payment approval',
  },

  vinDashboard: {
    registered: 'Registered',
    unregistered: 'Unregistered',
    retailSold: 'Retail Sold - STAT Survey',
  },

  saleOrderDashboard: {
    new: 'New',
    delivered: 'Delivered',
    invoiced: 'Invoiced',
    cancelled: 'Cancelled',
  },

  viewDealerUserDialog: {
    removeLabel: 'Remove',
    undoLabel: 'Undo',
    saveEditConfirmationMessage: 'Are you sure you want to make the following changes to user {email}?',
    addedSelectedLocation: 'Adding Selected Location: {dealerName}',
    addedSelectedChainGroup: 'Adding Selected Chain Group: {dealerName}',
    addSelectedLocationBtnLabel: 'Add Selected Location',
    pleaseSelectLocationToAddLabel: 'Please Select Location to Add',
  },

  completeDealerInvite: {
    title: 'Complete Dealer Invitation',
    password: 'Password *',
    passwordRequired: 'Password is required',
    confirmPassword: 'Confirm Password *',
    confirmPasswordRequired: 'Confirm Password is required',
    passwordDoesNotMatch: 'Password and Confirm Password must match.',
    invitationSuccessMessage: 'Success! Your account has been created',
    invalidTokenTitle: 'Invitation Token Invalid',
    invalidTokenMessage: 'A new invitation email has been sent. Please follow the link and try again.',
  },

  warrantyRegistrations: {
    pageTitle: 'Warranty Registrations ',
    tableColumnNames: {
      vin: 'Vin',
      brand: 'Brand',
      model: 'Model',
      year: 'Year',
      status: 'Status',
      dealerSold: 'Dealer Sold',
      hasRecall: 'Has Recall',
      ownerName: 'Owner Name',
      completedDate: 'Completed',
      shipDate: 'Shipped',
      registrationDate: 'Registered',
      accountNumber: 'Account #',
    },
    filterType: 'Filter Type',
    registeredButtonLabel: 'Registered',
    unregisteredButtonLabel: 'Unregistered',
    dialogTitle: 'Confirm',
    signatureConsensus:
      'By selecting "Confirm", you are acknowledging that there is a copy of the owners registration on file, including all the appropriate Dealer and Consumer signatures',
    includeExpiredLabel: 'Include Expired',
    updateOwner: 'Update Owner',
    register: 'Register',
    retailSoldLabel: 'Retail Sold - STAT Survey',
    retailSoldStatSurveyHtml:
      'The customer signed registration needs to be sent to: <a href="mailto:{hrvRegistrationEmail}">{hrvRegistrationEmail}</a> (HRV units) or <a href="mailto:{dcrvRegistrationEmail}">{dcrvRegistrationEmail}</a> (CRV/DRV) units',
    notRegisteredLabel: 'Unregistered',
    ...WarrantyRegistrationsi18n
  },

  warrantyClaims: {
    pageTitle: 'Warranty Claims ',
    searchLabel: 'Search',
    filterTypeLabel: 'Filter Type',
    claimStatusLabel: 'Claim Status',
    tableColumnNames: {
      claimNumber: 'Claim #',
      vin: 'Vin',
      accountNumber: 'Account #',
      status: 'Status',
      inServiceDate: 'In Service Date',
      updated: 'Updated',
      workOrderNumber: 'Work Order #',
      checkNumber: 'Check #',
      totalAmount: 'Total Amount',
      venderChargeback: 'Vendor Chargeback',
      recallId: 'Recall ID',
      autoDenied: 'Auto Denied',
    },
    newClaimLabel: 'New Claim',
    exportClaims: 'Export Claims',
    exportDownloadSuccess: 'Success! {fileName} successfully downloaded!',
    includeClosedLabel: 'Include Closed',
  },

  newClaimDialog: {
    title: 'Create New Claim',
    recallTitle: 'Create New Claim From Recall',
    accountNumber: 'Account',
    accountName: 'Account Name',
    vin: 'Vin',
    brand: 'Brand',
    year: 'Year',
    recall: 'Recall ID',
    workOrderNumber: 'Work Order #',
    inServiceDate: 'In Service Date',
    remedyCode: 'Remedy Code',
    vinSelectionRquired: 'Vin selection required!',
    inServiceDateRequired: 'In Service Date selection required!',
    newClaimSuccess: 'New claim successfully created',
    confirmExistingRecall:
      'This VIN {vin} has existing recalls (e.g., {recalls}). </br></br> By selecting "Confirm", you acknowledge to proceeding claim creation without existing recall.',
    createSuccess: 'Claim {claimNumber} successfully created!',
  },

  claimDetail: {
    pageTitle: 'Claim Detail',
    claimCardHeader: 'Claim',
    customerHeader: 'Customer',
    ownerHeader: 'Owner',
    lines: 'Lines',
    claimId: 'Claim Id',
    vin: 'VIN',
    custAccount: 'Account #',
    brand: 'Brand',
    year: 'Year',
    model: 'Model',
    claimType: 'Claim Type',
    recallId: 'Recall Id',
    workOrderNumber: 'Work order no.',
    workCompleted: 'Work Completed',
    partsCostSubmitted: 'Parts/Misc Cost Submitted',
    submittedPayment: 'Submitted for Payment',
    status: 'Status',
    inServiceDate: 'In Service Date',
    saveChangesMissingError: 'Missing {error}',
    dateOutOfService: 'Date Out of Service',
    claimTotal: 'Claim Total',
    laborTotal: 'Labor Total',
    checkNumber: 'Check #',
    name: 'Name',
    address: 'Address',
    addLine: 'Add Line',
    line: 'Lines',
    saveChanges: 'Save Changes',
    saveChangesMsg: 'Are you sure you want to save your changes to Claim {claimNumber}?',
    claimSubmitSuccess: 'Claim successfully submitted.',
    submitPreAuth: 'Submit Pre-Authorization',
    submittedPreAuthMsg: 'Are you sure you want to submit Claim {claimNumber} for Pre-Authorization?',
    submittedPreAuth: '* Submitted for Pre-Authorization *',
    submittedWorkComplete: '* Submitted for Work Complete *',
    pendingChangesTitle: 'Pending Changes',
    pendingChangesMsg:
      'All changes must be saved before performing any other actions. Please save changes and try again.',
    linesReqTitle: 'Lines Required',
    linesReqMsg: 'Pre-Authorization cannot be submitted without any lines.',
    workComplete: 'Work Complete',
    workCompleteMsg: 'Are you sure you want to submit Claim {claimNumber} for Work Complete?',
    upsReturnLabel: 'UPS Return Label',
    claimSaveSuccess: 'Success! Claim changes saved',
    unsavedChanges: 'There are unsaved changes. Are you sure you want to leave?',
    unsavedChangesReturnMessage: 'Unsaved changes. Cannot perform action.',
    amountRule: 'Amount must be greater than 0',
    reasonEntryRequired: 'Reason entry required. *',
    lineTableColumns: {
      warrantyClassCode: 'FRC',
      description: 'Description',
      remedyCode: 'Remedy Code',
      failureCode: 'Failure Code',
      status: 'Status',
      subletAmount: 'Sublet Amount',
      laborRate: 'Labor Rate',
      frcHours: 'FRC Hours',
      hoursRequested: 'Hours Requested',
      hoursApproved: 'Hours Approved',
      awaitingPartsReturn: 'Awaiting Parts Return',
      awaitingPhoto: 'Awaiting Photo',
      workCompleted: 'Work Completed',
      dealerCanceled: 'Dealer Canceled/Denied',
      reason: 'Reason',
      selectContent: 'Select Content',
    },
    removeDialogTitle: 'Remove {prop}',
    removeDialogMsg: 'Are you sure you want to remove {prop} {id}?',
    exitDetails: 'Exit Claim Details',
  },

  addClaimLineDialog: {
    addClaimLine: 'Add New Claim Line',
    warrantyClass: 'Warranty Class',
    subClass: 'Sub Class',
    specific: 'Specific',
    failureCode: 'Failure Code',
    remedyCode: 'Remedy Code',
    required: 'Required *',
    remedyCodeRequired: 'Remedy Code Required *\n If no results, try a different warranty class combination',
    addSuccess: 'Line successfully added',
  },

  addClaimLineItemDialog: {
    addLineItem: 'Add New Line Item',
    quantity: 'Quantity',
    quantityRequired: 'Quantity Required.* Must be greater than 0',
    itemRequired: 'Item selection required.*',
    addSuccess: 'Line item successfully added',
    recentlyOrderedLabel: 'Recently Ordered Items',
  },

  addClaimLineMiscChargeDialog: {
    addLineMiscCharge: 'Add New Line Misc. Charge',
    markupCode: 'Markup Code',
    amount: 'Amount',
    description: 'Description',
    addSuccess: 'Line item successfully added',
  },

  addClaimLineAttachmentDialog: {
    addLineAttachment: 'Add New Line Attachment',
    lineAttachment: 'Line Attachment',
    addSuccess: 'Line attachment/s successfully added',
  },

  addClaimLineNoteDialog: {
    addLineNote: 'Add New Line Note',
    note: 'Note',
    addSuccess: 'Line note successfully added',
  },

  claimLineTabDetails: {
    item: 'Item',
    miscCharge: 'Misc. Charge',
    attachment: 'Attachment',
    note: 'Note',
    tabs: {
      items: 'Items',
      miscCharges: 'Misc. Charges',
      attachments: 'Attachments',
      notes: 'Notes',
    },
    addItemBtn: 'Add Item',
    itemTableColumns: {
      itemNumber: 'Item No.',
      description: 'Description',
      quantity: 'Quantity',
      price: 'Price',
      status: 'Status',
      declineReason: 'Decline Reason',
    },
    addMiscChargeBtn: 'Add Misc. Charge',
    miscChargeTableColumns: {
      markupCode: 'Markup Code',
      amount: 'Amount',
      description: 'Description',
      status: 'Status',
      declineReason: 'Decline Reason',
    },
    addAttachmentBtn: 'Add Attachment',
    attachmentsTableColumns: {
      type: 'Type',
      description: 'Description',
      fileName: 'File Name',
      url: 'URL',
      image: 'Image',
      created: 'Created',
      createdBy: 'CreatedBy',
    },
    addNoteBtn: 'Add Note',
    notesTableColumns: {
      name: 'Name',
      userId: 'User ID',
      note: 'Note',
      created: 'Created',
    },
    addAttachment: 'Add Attachment',
    addNotes: 'Add Note',
  },

  createReturnLabelDialog: {
    title: 'Create UPS Return Label',
    emailSentVerbiage: 'Email label will be sent to:',
    emailLabel: 'Email',
    packageDimensionsVerbiage: 'Package dimensions in inches:',
    lengthLabel: 'Length',
    widthLabel: 'Width',
    heightLabel: 'Height',
    packageWeightVerbiage: 'Package weight in Pounds:',
    weightLabel: 'Weight',
    inches: 'inches',
    pounds: 'pounds',
    successMessage:
      'Success! Your return label has been successfully submited. You will recieve your label shortly at {email}.',
  },

  salesOrders: {
    pageTitle: 'Sales Orders ',
    searchOrderNumLabel: 'Search Sales Order #',
    searchReqNumLabel: 'Search Requisition #',
    filterTypeLabel: 'Filter Type',
    orderStatusLabel: 'Sales Order Status',
    rvPartsStock: 'RV Parts and Stock',
    rvUnit: 'RV Unit',
    tableColumnNames: {
      msrp: 'MSRP',
      salesOrderNumber: 'Sales Order #',
      vin: 'vin',
      status: 'Status',
      createdDate: 'Created Date',
      latestStatusUpdate: 'Latest Status Update',
      customerRequisition: 'Customer Requisition #',
      requisitionNumber: 'Cust. Requisition #',
      modeOfDelivery: 'Mode of Delivery',
    },
  },

  salesOrderDetail: {
    dialogHeader: 'Sales Order Details',
    salesOrderNumber: 'Sales Order #: ',
    vin: 'VIN: ',
    model: 'Model: ',
    brand: 'Brand: ',
    shipDate: 'Ship Date',
    year: 'Year: ',
    accountName: 'Name: ',
    customerAccount: 'Customer Account: ',
    invoiceAccount: 'Invoice Account: ',
    contact: 'Contact: ',
    requestedShipDate: 'Ship Date: ',
    status: 'Status: ',
    documentStatus: 'Document Status: ',
    customerReference: 'Customer Reference: ',
    customerReferenceAbbrv: 'Cust. Reference: ',
    customerRequisition: 'Customer Requisition: ',
    customerRequisitionAbbrv: 'Cust. Requisition: ',
    pool: 'Pool: ',
    site: 'Site: ',
    warehouse: 'Warehouse: ',
    salesOrderLines: 'Lines',
    salesOrderLinesColumnsNames: {
      itemNumber: 'Item Number',
      productName: 'Product Name',
      quantity: 'Quantity',
      unitOfMeasure: 'UoM',
      netAmount: 'Net Amount',
      readyForPickUp: 'Ready for Pick Up',
      readyForPickUpDate: 'Ready for Pick Up Date',
      readyForPickUpDateAbbrv: 'Pick Up Date'
    },
    salesOrderTrackingColumnsNames: {
      shipmentVoided: 'Shipment Voided: ',
      leadTrackingNumber: 'Lead Tracking #: ',
      trackingNumber: 'Tracking #: ',
      modeOfDelivery: 'Mode of Delivery: ',
      actualShipDate: 'Ship Date: ',
    },
    deliveryName: 'Name: ',
    deliveryInfo: 'Delivery Information',
    address: 'Address: ',
    shipmentVoided: 'Shipment Voided: ',
    trackingInfo: 'Tracking Information',
    inventoryInfo: 'Inventory',
    leadTrackingNumber: 'Lead Tracking #: ',
    trackingNumber: 'Tracking #: ',
    salesOrderInfo: 'Sales Order',
    modeOfDelivery: 'Mode of Delivery: ',
    actualShipDate: 'Ship Date: ',
  },

  vinDetail: {
    dialogHeader: 'VIN Details',
    vin: 'VIN:',
    itemNumber: 'Item Number',
    site: 'Site:',
    name: 'Name:',
    warrantyStatus: 'Warranty Status',
    registered: 'Registered:',
    brand: 'Brand:',
    model: 'Model:',
    year: 'Year:',
    contactID: 'ContactID:',
    customersSignature: "Customer's Signature:",
    ownersHistoryLabel: 'Owners History',
  },

  vinDetailsDialog: {
    tableColumnNames: {
      ownerName: 'Name',
      activationDate: 'Activation Date',
      inactiveDate: 'Inactive Date',
      ownerStatus: 'Owner Status',
      inactiveReason: 'Inactive Reason',
      inServiceDate: 'In Service Date',
    },
  },

  adminDealerRegistration: {
    title: 'Complete Dealer Admin Invitation',
    firstName: 'First Name *',
    lastName: 'Last Name *',
  },

  registerVehicle: {
    pageTitle: 'Register Vehicle',
    vehicleDetailLabels: {
      heading: 'Vehicle',
      vin: 'VIN',
      brand: 'Brand',
      model: 'Model',
      year: 'Year',
    },
    ownerInfoLabels: {
      heading: 'Owner Information',
      firstname: 'Firstname',
      lastname: 'Lastname',
      street: 'Street',
      city: 'City',
      state: 'State',
      postalCode: 'Zip/Postal Code',
      country: 'Country *',
      countryRequired: 'Country is required',
      phone: 'Phone',
      email: 'Email',
      dateSold: 'Date Sold',
      customerSignature: 'Customer Signature',
    },
    salesInformationHeading: 'Sales Information',
    purchaseDate: 'Purchase Date *',
    purchaseDateRequired: 'Purchase Date is required',
    purchaseDateCannotBeInFuture: 'Purchase Date cannot be a date in the future',
    customerSignatureConfirmLabel: 'Confirmed Customer Signature *',
    customerSignatureRequired: 'Customer signature must be confirmed',
    registrationSuccessful: 'Success! VIN: {vin} registered',
    primaryOwnerFirstName: 'Primary Owner First Name *',
    secondaryOwnerFirstName: 'Secondary Owner First Name',
    firstNameRequired: 'First Name is required',
    primaryOwnerLastName: 'Primary Owner Last Name *',
    secondaryOwnerLastName: 'Secondary Owner Last Name',
    lastNameRequired: 'Last Name is required',
    email: 'Email *',
    emailRequired: 'Email is required',
    phone: 'Phone Number *',
    phoneError: 'Please enter a valid phone number',
    secondaryPhone: 'Secondary Phone Number',
    fax: 'Fax',
    streetAddress: 'Street Address *',
    streetAddressRequired: 'Street Address is required',
    city: 'City *',
    cityRequired: 'City is required',
    zip: 'Zip / Postal Code *',
    zipRequired: 'Zip / Postal Code is required',
    state: 'State / Province *',
    stateRequired: 'State / Province is required',
    country: 'Country *',
    countryRequired: 'Country is required',
    register: 'Register',
    invalidPostalTitle: 'Invalid Postal Code',
    invalidPostalMessage:
      'Check country and postal code input and try again or contact Heartland Customer Service for assistance.',
  },

  vinTypeAhead: {
    inputHint: 'Minimum 6 characters to trigger filtering',
    searchVin: 'Search Vin',
  },

  productTypeAhead: {
    inputHint: 'Minimum 4 characters to trigger filtering',
    searchItem: 'Search Item By ID or Description',
  },

  recallDropdown: {
    findRecall: 'Find Recall',
    label: 'Recall ID',
  },

  products: {
    pageTitle: 'Products / Items',
    searchCriteriaLabel: 'Search Criteria',
    tableColumnNames: {
      itemNumber: 'Item #',
      itemDescription: 'Item Description',
      salesPrice: 'Price',
      image: 'Image',
      warrantyClassCode: 'Warranty Class Code',
    },
    itemIdDescriptionSearchLabel: 'Item ID or Description',
    supplierNumberSearchLabel: 'Vendor Part #',
    dropDownLabels: {
      brand: 'Brand',
      modelyear: 'Year',
    },
    itemOnBackOrderTitle: 'OUT OF STOCK',
    itemOnBackOrderMessage: '{itemDescription} is currently not in stock. Would you like to order this item?',
    or: '- OR -',
    showTopItems: 'Show Top Items',
    topItemsInfo: '* Results reflect the top ordered items *',
  },

  productDetails: {
    dialogHeader: 'Product Details',
    itemNumberLabel: 'Item #',
    productNameLabel: 'Product Name',
    salesPriceLabel: 'Price',
    unitLabel: 'Unit',
    currencyLabel: 'Currency',
    quantityLabel: 'On hand quantity',
    brandLabel: 'Brand',
    modelLabel: 'Model',
    yearLabel: 'Year',
    supplierNumLabel: "Supplier Part #'s",
    categoryLabel: 'Category',
    subcomponentLabel: 'Subcomponents',
    alternateItemMessage: 'Item # {itemNumber} is not available and is swapped to alternate Item # {altItemNumber}',
  },

  shoppingCart: {
    pageTitle: 'Shopping Cart',
    tableColumnNames: {
      itemNumber: 'Item #',
      itemDescription: 'Item Description',
      quantity: 'Quantity',
      unitOfMeasure: 'UoM',
      prodSubComponent: 'Product Sub-Component',
      price: 'Price',
      backorder: 'Backorder',
      additionalNotes: 'Notes',
    },
    noteDialogMessage: 'Add or Edit item note',
    itemRemoveTitle: 'Confirm Remove',
    itemRemoveMessage: 'Are you sure you want to remove Item {itemDescription}',
    checkoutBtnLabel: 'Checkout',
    noteRequiredPlaceholder: 'Note Entry Required*',
    notePlaceholder: 'Enter note*',
    quantityMessage: 'Quantity must be greater than 0',
    checkoutIncompleteTitle: 'Cart Incomplete',
    checkoutIncompleteMessage: 'Please add notes where required.',
  },

  cartBase: {
    addSuccess: 'Success! Item # {itemNumber} sucessfully added to cart.',
  },

  cartCheckout: {
    pageTitle: 'Checkout',
    orderInformationPageTitle: 'Order Information',
    orderReviewPageTitle: 'Order Review',
    orderInformationTitle: 'Order Information',
    contactInformationTitle: 'Contact Information',
    customerNumberLabel: 'Customer Number',
    customerNumberRequired: 'Customer number required',
    customerReferenceLabel: 'Customer Reference',
    requisitionLabel: 'PO Number',
    modeOfDeliveryLabel: 'Mode of delivery *',
    modeOfDeliveryRequired: 'Mode of delivery required',
    orderTypeLabel: 'Order Type *',
    orderTypeRequired: 'Order type required',
    rvParts: 'RV Parts',
    stockParts: 'Stock Parts',
    purchaseTypeLabel: 'Purchase Type *',
    purchaseTypeRequired: 'Purchase type required',
    vinLabel: 'Vin',
    vinRequired: 'Order Type: "RV Parts" requires vin entry',
    shippingInformationTitle: 'Shipping Information',
    contactNameLabel: 'Contact Name*',
    contactNameRequired: 'Contact name required',
    contactEmailLabel: 'Contact Email*',
    contactEmailRequired: 'Contact email required',
    contactPhoneLabel: 'Contact Phone*',
    contactPhoneRequired: 'Contact phone required',
    deliveryNameLabel: 'Delivery Name *',
    deliveryNameRequired: 'Delivery name required',
    shipCompleteLabel: 'Ship Complete',
    oneTimeDeliveryAddressLabel: 'Create one-time delivery address',
    deliveryLocationLabel: 'Delivery Location',
    deliveryLocationRequired: 'Delivery location required. If none, try "one-time delivery address',
    deliveryAddressLabel: 'Delivery Address *',
    deliveryAddressRequired: 'Delivery address required. If none, try "one-time delivery address"',
    addressLabel: 'Address',
    shippingNameLabel: 'Shipping Name *',
    shipingNameRequired: 'Shipping name is required',
    shippingPhoneLabel: 'Shipping Phone *',
    shippingPhoneRequired: 'Complete shipping phone is required',
    shipTo: 'Ship To:',
    note: 'Note',
    totals: 'Totals',
    totalAmount: 'Total',
    currency: 'Currency',
    submitOrderTitle: 'Submit Order',
    submitOrderMessage: 'Are you sure you want to submit this order for customer {customer}?',
    orderItems: 'Order Items',
    salesOrderSuccessTitle: 'Order Success',
    salesOrderSuccessMessage:
      'Your order was successfully placed. Please use sales order: {salesOrderNumber} for reference.',
  },

  invoices: {
    pageTitle: 'Invoices',
    searchTermLabel: 'Search',
    filterTypeLabel: 'Filter Type',
    tableColumnNames: {
      invoiceNumber: 'Invoice #',
      vin: 'VIN',
      salesOrderNumber: 'Sales Order #',
      date: 'Date',
      dueDate: 'Due Date',
      currency: 'Currency',
      amount: 'Amount',
      referenceNumber: 'Reference #',
    },
  },

  invoiceDetails: {
    dialogHeader: 'Invoice {invoiceNumber}',
    invoiceInformation: 'Invoice Information',
    invoiceAccount: 'Invoice Account:',
    vin: 'VIN:',
    salesOrder: 'Sales Order:',
    invoiceDate: 'Invoice Date:',
    requisition: 'Requisition:',
    invoiceAmount: 'Invoice Amount:',
    totalCharges: 'Total Charges:',
    salesTax: 'Sales Tax:',
    totalDiscount: 'Total Discount:',
    paymentTerms: 'Payment Terms:',
    deliveryInformation: 'Delivery Information',
    name: 'Name:',
    address: 'Address:',
    recipientName: 'Recipient Name:',
    modeOfDelivery: 'Mode of Delivery:',
    invoiceLines: 'Invoice Lines',
    invoiceLinesTableColumns: {
      salesOrderNo: 'Sales Order #',
      itemNo: 'Item #',
      productName: 'Product Name',
      quantity: 'Quantity',
      unitPrice: 'Unit Price',
      lineDiscount: 'Line Discount',
      amount: 'Amount',
    },
  },

  w9: {
    navigationTitle: 'W9 Requests',
    list: {
      pageTitle: 'W9 Requests',
      newW9: 'New W9',
      filterLabel: 'Filter Type',
      commentDialogTitle: 'Comments',
      commentDialogNoComments: 'There are no comments on this W9 Request.',
      tableColumns: {
        requestorId: 'Requestor ID',
        dealerLocation: 'Dealer Location',
        status: 'Status',
        dateSubmitted: 'Date Submitted',
        updatedDate: 'Updated Date',
      },
    },
    request: {
      pageTitle: 'W9 Request Form',
      subTitle: 'Requesting Salesperson Info',
      phone: 'Phone Number',
      ssn: 'Social Security Number',
      documentUpload: 'Please Attach a Signed Copy of Current W9 Form for Review *',
      submitError:
        'W9 Document is either not uploaded or the upload has failed. Please check the document and try again.',
      upload: 'Upload',
      firstName: 'First Name *',
      lastName: 'Last Name *',
      validation: {
        successMessage: 'Your W9 request was successfully created.',
        firstNameRequired: 'First Name Required',
        lastNameRequired: 'Last Name Required',
        ssnRequired: 'Please enter a valid SSN Number',
        phoneRequired: 'Please enter a valid phone number',
        locationRequired: 'Please select a location',
      },
    },
  },

  addItemPrompt: {
    itemQuantity: 'Item Quantity',
    itemQuantityRequired: 'Item quantity required',
    unitOfMeasure: 'Unit of Measure',
    unitOfMeasureRequired: 'Unit of Measure Required',
    addCartTitle: 'Add Item: ',
  },

  announcementCard: {
    published: 'Published',
    attachment: 'Attachments',
    description: 'Description',
  },

  spiff: {
    pageTitle: 'SPIFF Request',
    searchSpiffId: 'SEARCH BY SPIFF ID',
    status: 'Status',
    columns: {
      confirm: 'Confirm',
      vin: 'VIN',
      spiffId: 'Spiff ID',
      model: 'Model',
      brand: 'Brand',
      year: 'Year',
      amount: 'Amount',
      status: 'Status',
      type: 'Spiff Type',
      name: 'Name',
      company: 'Company',
      requestingSalesman: 'Requesting Sales Rep',
    },
    requestFormTitle: 'SPIFF Request Form',
    uploadInstructions: 'Would you like to attach a document?',
    documentTypeLabel: 'Please select a document type to upload a copy of your proof of ownership: *',
    uploadDocTypeRequired: 'Document type selection required. Make selection and try again.',
    successSalesMessage: 'Your SPIFF has been successfully submitted for:',
    successDealerMessage: 'Your SPIFF has been successfully submitted',
    registrationRequiredTitle: 'Vehicle Not Registered',
    registrationRequiredMessage:
      'A Spiff cannot be requested until the vehicle is registered. You will be redirected to the vehicle registration form.',
    selectSalesman: 'Select Sales Rep',
  },

  spiffSearchTypes: {
    vin: 'VIN',
    spiffId: 'Spiff ID',
    status: 'Status',
  },

  spiffDetails: {
    dialogHeader: 'Spiff {spiffId}',
    spiffInformation: 'Spiff Information',
    paymentInformation: 'Payment Information',
    checkNumber: 'Check Number',
    date: 'Date',
    recipientName: 'Recipient Name',
    address: 'Address',
  },

  marketingMaterials: {
    pageTitle: 'Marketing Materials',
    marketingMaterialsVerbiage: 'Looking for Marketing Materials and Heartland Swag?',
    dealerStoreVerbiage: 'Click to visit our Dealer Store!',
    moreFeatures: 'More Features',
    comingSoon: 'Coming Soon',
  },

  rvFaq: {
    title: 'Frequently Asked Questions',
  },

  /////////////////////////////////////////////////////////////////////////////////
  // Shared

  action: 'Action',
  add: 'Add',
  all: 'All',
  cancel: 'Cancel',
  clear: 'Clear',
  confirm: 'Confirm',
  close: 'Close',
  delete: 'Delete',
  edit: 'Edit',
  error: 'Error',
  alert: 'Alert',
  continue: 'Continue',
  errorInstruction: 'Please fix the following errors:',
  failed: 'Action failed',
  goBack: 'Go Back',
  name: 'Name',
  noResults: 'No results',
  OK: 'OK',
  reset: 'Reset',
  submit: 'Submit',
  saveChanges: 'Save Changes',
  success: 'Success',
  unexpectedError: 'Unexpected error. Please try again.',
  search: 'Search',
  users: 'Users',
  documents: {
    sizeError: 'Max document size is {maxSizeBytes} MB',
    typeError:
      'Document with extension {fileExtension} is not supported. Supported document types include {supportedExtensions}',
    numberError: 'Only {maxNumber} file(s) supported with upload',
    defaultError: 'An unexpected error occurred uploading your file. Please try again.',
  },
  goBackButtonLabel: 'Back to {routeName}',
  emptyDataMessage: 'No data available',
  yes: 'Yes',
  no: 'No',
  view: 'View',
  viewedit: 'View / Edit',
  email: 'Email',
  firstName: 'First Name',
  lastName: 'Last Name',
  roles: 'Roles',
  createdDate: 'Created Date',
  currentTitle: 'Current Title',
  brand: 'Brand:',
  year: 'Year:',
  model: 'Model:',
  searchCriteriaLabel: 'Search Criteria',
  required: 'Required *',
  filterType: 'Filter Type',
  unableViewFileLabel: 'Unable to View File',
  unableViewFileMsg: 'File is too large or an error occured. Please try downloading file instead.',
  details: 'Details',
  more: 'More...',
  information: 'Information',
  numericValue: 'Must be numeric value *',
  valueLessThan: 'Value must be less than {maxValue}'
};
